import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutnordeste() {
  return <TablaConciliacion nombreUseCase="AUTOPISTASNORDESTE" titulo="AUTOPISTA NORDESTE" />;
}

export default TablaAutnordeste;
